import type { Editor } from "grapesjs";

export const panelConfigOptions = (editor: Editor) => {
  // OPCION PANELS
  //   editor.Panels.removeButton("options", "sw-visibility");
  editor.Panels.removeButton("options", "preview");
  editor.Panels.removeButton("options", "fullscreen");
  editor.Panels.removeButton("options", "export-template");
  //   editor.Panels.removeButton("options", "undo");
  //   editor.Panels.removeButton("options", "redo");
  editor.Panels.removeButton("options", "gjs-open-import-webpage");
  //   editor.Panels.removeButton("options", "canvas-clear");
};
